import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginPage } from './login.page';
import { TermsPage } from './terms/terms.page';

const routes: Routes = [
  {
    path: '',
    component: LoginPage
  },
  {
    path: 'terms',
    component: TermsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginPageRoutingModule {}
